<app-button type="outline" queryParamsHandling="preserve" [routerLink]="route">
  <svg-icon src="assets/icons/Arrows/arrow-narrow-left.svg" />
  @if (text) {
    {{ text }}
  } @else {
    {{ 'components.backButton.label' | translate }}
  }
</app-button>
